import template from './warningRequestVacation.html';
import controller from './warningRequestVacation.controller';
import './warningRequestVacation.scss';

let warningRequestVacationComponent = {
  restrict: 'E',
  bindings: {
    date: '<',
    onDismiss: '&',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default warningRequestVacationComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/warningRequestVacation/warningRequestVacation.component.js